import { defineMessages } from 'react-intl';

const _default_1: {
	cancelLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	discardLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	warningIconLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	yesLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	cancelLabel: {
		id: 'fabric.editor.ai.screens.discard.cancelLabel',
		defaultMessage: 'Back',
		description:
			'Text for the "Back" button on the "Discard Warning" screen, used to prevent discarding changes and return to the previous screen',
	},
	discardLabel: {
		id: 'fabric.editor.ai.screens.discard.discardLabel',
		defaultMessage: 'Discard',
		description:
			'Text for the "Discard" button on the "Discard Warning" screen, used to confirm the user intention to discard unsaved changes, whether in relation to prompt input or a generated response. The term should convey the meaning of intentionally discarding or abandoning the modifications made or the generated content.',
	},
	warningIconLabel: {
		id: 'fabric.editor.ai.screens.discard.warningIconLabel',
		defaultMessage: 'Warning',
		description: 'Aria label for the warning icon on the "Discard Warning" screen',
	},
	yesLabel: {
		id: 'fabric.editor.ai.screens.discard.yesLabel',
		defaultMessage: 'Yes',
		description:
			'Text for the "Yes" button on the "Discard Warning" screen, used to keep the current changes',
	},
	noLabel: {
		id: 'fabric.editor.ai.screens.discard.noLabel',
		defaultMessage: 'No',
		description:
			'Text for the "No" button on the "Discard Warning" screen, used to delete the current changes',
	},
});
export default _default_1;
